import { ResidentTypesEnum } from '../../../common/enums/resident-types.enum';
import { camelCaseToRegularForm } from '../../../common/helpers/camel-case-to-regular-form.helper';
import featureStore from '../../../common/stores/features/feature.store';

export const residentTypeOptions = Object.entries(ResidentTypesEnum).map(([key, value]) => ({
  label: camelCaseToRegularForm(key),
  value: value,
}));

export const getResidentTypeOptions = () =>
  residentTypeOptions.filter((option) => option.value !== ResidentTypesEnum.RentalAgency || featureStore.isRentalPortalEnabled);
